import { makeAsyncActionTypes } from 'uf/data/ActionTypes';

// disable this until we have more exports in this file.
export const searchActionTypes = makeAsyncActionTypes('uf/search');
